import EventTracker from "../eventTracker";
import EventTypes from "../constants/EventTypes";

export function getSurveyResponses(aPatientId, aSurveyVersionCollectionId, aLimit, aOffset, aIncludeDeleted = false, aCompleted = true){
  EventTracker.track(EventTypes.FETCH_SURVEY_RESPONSES);
  let query = `
    query getSurveyResponsePage ($company_id: ID!, $user_id: ID!, $survey_id: ID, $survey_version_collection_id: ID, $offset: Int, $limit: Int, $include_deleted: Boolean, $completed: Boolean) {
      survey_response_page (company_id: $company_id, user_id: $user_id, survey_id: $survey_id, survey_version_collection_id: $survey_version_collection_id, offset: $offset, limit: $limit, include_deleted: $include_deleted, completed: $completed){
        survey_responses {
          id
          admin_id
          complete
          progress
          admin_name
          created_at
          deleted_at
          lock_state
          updated_at
          completed_at
          completed_by_admin
          survey {
            id
            name
            reference
          }
          important_questions {
            key
            label
            survey_response_detail_value
          }
        }
        total
      }
    }
  `;
  let variables = {};
  
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['user_id'] = aPatientId;
    variables['limit'] = aLimit;
    variables['offset'] = aOffset;
    variables['completed'] = aCompleted;
    variables['include_deleted'] = aIncludeDeleted;
    variables['survey_version_collection_id'] = aSurveyVersionCollectionId;
    return global.api.post("/queries", { query, variables });
  };
}

export function deleteSurveyResponse(aSurveyResponseId){
  EventTracker.track(EventTypes.DELETE_SURVEY_RESPONSE);
  let graphQLQuery = `
    mutation DeleteSurveyResponse($surveyResponseId: ID!, $companyId: ID!) {
      deleteSurveyResponse(input: {
        survey_response_id: $surveyResponseId
        company_id: $companyId
      }) {
        deleted_id
      }
    }
  `;

  return (dispatch, getState) => {
    let state = getState();
    let variables = {
      companyId: state.company && state.company.company && state.company.company.id,
      surveyResponseId: aSurveyResponseId
    };
    return global.api.post("/queries", { query: graphQLQuery, variables });
  };
}

export function restoreSurveyResponse(aSurveyResponseId){
  EventTracker.track(EventTypes.RESTORE_SURVEY_RESPONSE);
  let graphQLQuery = `
    mutation RestoreSurveyResponse($surveyResponseId: ID!, $companyId: ID!) {
      restoreSurveyResponse(input: {
        survey_response_id: $surveyResponseId
        company_id: $companyId
      }) {
        restored_id
      }
    }
  `;

  return (dispatch, getState) => {
    let state = getState();
    let variables = {
      companyId: state.company && state.company.company && state.company.company.id,
      surveyResponseId: aSurveyResponseId
    };
    return global.api.post("/queries", { query: graphQLQuery, variables });
  };
}
